<script setup>
import BigBannersGrid from "~/components/organisms/BigBannersGrid.vue";

const props = defineProps({
  data: {
    type: Object,
  }
})
</script>

<template>
  <BigBannersGrid :banners="props.data.banners" :settings="props.data?.settings"/>
</template>
